import React, { useState } from 'react'
import { BaseView, BaseText } from '@/components/base'
import { CurrencyAvatar } from '@/components/CurrencyAvatar'
import { useConversionScopedStore } from '@/store/scoped'
import { useCryptoConversion } from '../../hooks'
import { useTheme } from '@/hooks/useTheme'
import { ChevronDown } from '@/assets/icons'
import { ConversionCurrencyBottomSheet } from '../ConversionCurrencyBottomSheet'

interface CryptoSelectorProps {
  type: 'from' | 'to'
  currencyInfoInWallet?: any
}

export const CryptoSelector: React.FC<CryptoSelectorProps> = ({
  type,
  currencyInfoInWallet,
}) => {
  const theme = useTheme()
  const [isCurrencyModalOpen, setIsCurrencyModalOpen] = useState(false)

  const debitWallet = useConversionScopedStore(
    (state) => state.conversion.from.currencyInfoInWallet,
  )
  const creditWallet = useConversionScopedStore(
    (state) => state.conversion.to.currencyInfoInWallet,
  )
  const { handleSelectCryptoFromBottomSheet } = useCryptoConversion()

  const handleOpenCurrencyModal = () => {
    setIsCurrencyModalOpen(true)
  }

  const handleCloseCurrencyModal = () => {
    setIsCurrencyModalOpen(false)
  }

  const handleCurrencySelect = (selectedCurrency: any) => {
    handleSelectCryptoFromBottomSheet(type, selectedCurrency.code)
    handleCloseCurrencyModal()
  }

  if (!currencyInfoInWallet) return null

  return (
    <>
      <BaseView
        onClick={handleOpenCurrencyModal}
        style={{
          cursor: 'pointer',
          flexDirection: 'row',
          alignItems: 'center',
          gap: 8,
          paddingLeft: 12,
          paddingRight: 12,
          paddingTop: 8,
          paddingBottom: 8,
          backgroundColor: theme.colors.background.cardItemRoot,
          borderRadius: 20,
        }}
      >
        {/* Иконка валюты - как в RN Avatar с isCurrency=true */}
        <CurrencyAvatar
          uri={currencyInfoInWallet?.icon}
          bgColor={currencyInfoInWallet?.avatarBGRefColor}
          size={28}
          iconSize={18}
          fallbackText={currencyInfoInWallet?.code?.substring(0, 2) || '?'}
        />

        {/* Код валюты */}
        <BaseText fontSize={16} fontFamily="semibold" color="label.default">
          {currencyInfoInWallet?.displayCurrencyCode ||
            currencyInfoInWallet?.code}
        </BaseText>

        {/* Стрелка вниз */}
        <ChevronDown size={24} color={theme.colors.label.description} />
      </BaseView>

      {/* Модальное окно выбора валюты */}
      <ConversionCurrencyBottomSheet
        isOpen={isCurrencyModalOpen}
        onClose={handleCloseCurrencyModal}
        onCurrencySelect={handleCurrencySelect}
        excludeCurrencies={[
          // Исключаем обе уже выбранные валюты
          debitWallet?.code,
          creditWallet?.code,
        ].filter(Boolean)}
        type={type}
      />
    </>
  )
}
